<template>
  <div>
    <a-config-provider class="market-empty">
      <template #renderEmpty>
        <a-empty :image="emptyIcon" :image-style="{ height: '96px' }">
          <template #description>
            <span class="empty-text">{{
              marketCurrent === "myMarket" ? $t("market.noDataDesc") : $t("market.noData")
            }}</span>
          </template>
          <a-button v-if="marketCurrent === 'myMarket'" @click="addOptional" type="primary">{{
            $t("market.addFavorites")
          }}</a-button>
        </a-empty>
      </template>
      <a-table
        class="market-table"
        :class="{ tableWithKLine: showKLine }"
        rowKey="name"
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
      >
        <template slot="name" slot-scope="text, record">
          <p
            class="flex-box market-table-name"
            :class="{ 'market-table-name-noCollect': !showCollect }"
          >
            <i
              v-if="showCollect"
              class="icon-start table-icon-start"
              :class="{ ' star-light': isCollected(record.name) }"
              @click="marketClick(record.name)"
            ></i>
            <!--星星高亮class star-light -->
            <span>{{ record.name }}</span>
            <!-- <span class="f-gray ml-4">perpetual</span> -->
          </p>
        </template>
        <template slot="price" slot-scope="text, record">
          <p v-if="record.contractType === 'E'">
            <span>{{ record.close }}</span>
          </p>
          <p v-else class="flex-box-column">
            <span>{{ record.closes }}</span>
            <span class="f-12 f-gray f-not-weight">{{ record.close.price }}</span>
          </p>
        </template>
        <template slot="chart" slot-scope="text, record">
          <charts
            height="32px"
            width="120px"
            :dataList="getChardDataList(record)"
            :colorCls="getKeyLineClass(record)"
          />
        </template>
        <template slot="roses" slot-scope="text, record">
          <span v-if="record.contractType === 'E'" :class="getFutureRoseClass(record.rose)"
            >{{ (record.rose * 100).toFixed(2) }}%</span
          >
          <span :class="itemRoseClass(record.rose)">{{ record.roses }}</span>
        </template>
        <template slot="vol" slot-scope="text, record">
          <span v-if="record.contractType === 'E'">
            <span>{{ formatNumber(record.vol * multiple(record)) }}</span>
            <span v-if="record.vol !== '--'">
              <span> {{ record.name.match(/(\S*)USDT/)[1] }}</span>
            </span>
          </span>
          <span v-else>
            <span>{{ formatNumber(record.vol) }}</span>
            <span v-if="record.vol !== '--'">
              <span> {{ record.symbol.symbol }}</span>
            </span>
          </span>
        </template>
        <template slot="amount" slot-scope="text, record">
          <span>{{ formatNumber(record.amount) }} USDT</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <template>
            <c-button
              v-if="record.contractType !== 'E' && !fromHome"
              height="32px"
              style="font-size: 14px"
              @click="openModal(record.name)"
            >
              {{ $t("market.text1") }}
            </c-button>
            <c-button
              height="32px"
              style="font-size: 14px; margin-left: 8px"
              @click="bandLink(record.name, record)"
            >
              {{ $t("market.text2") }}
            </c-button>
          </template>
        </template>
      </a-table>
    </a-config-provider>
    <p v-if="fromHome && tableData.length" class="view-more blue-cl" @click="$router.push({path: '/market', query: {current: marketCurrent}})">
      {{ $t("header.more") }}
      <svg-icon iconClass="arrow-right" className="icon-14 ml-8"></svg-icon>
    </p>
    <MarketModal ref="marketModal"></MarketModal>
  </div>
</template>

<script>
import emptyIcon from '@/assets/svg/empty.svg';
import { myStorage } from '@/utilsui';
import { fixUpDownColor } from '@/utils/storage';
import MarketModal from './marketModal.vue';
import Charts from '../charts/miniChart.vue';

export default {
  components: {
    MarketModal,
    Charts,
  },
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    marketCurrent: {
      type: String,
      default: '',
    },
    fromHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptyIcon,
      pagination: {
        // 翻页数据
        total: 4, // 总数量
        pageSize: 10, // 每页显示条数
        page: 1, // 当前页数
      },
      loding: false,
      klineDataList: {},
      futureKlineDataList: {},
    };
  },
  computed: {
    /**
     * 首页不展示自选
     */
    showCollect() {
      return !this.fromHome;
    },
    // 合约列表
    contractList() {
      return this.$store.state.future.contractList;
    },
    /**
     * 首页不展示自选
     */
    showKLine() {
      return this.fromHome;
    },

    columns() {
      return [
        {
          title: this.$t('home.market'), // 市场
          dataIndex: 'name',
          key: 'name',
          // width: 200,
          scopedSlots: { customRender: 'name' },
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: this.$t('home.close'), // 最新价
          dataIndex: 'price',
          key: 'price',
          scopedSlots: { customRender: 'price' },
          sorter: (a, b) => {
            if (a.contractType === 'E') {
              return parseFloat(a.close) - parseFloat(b.close);
            }
            return parseFloat(a.closes) - parseFloat(b.closes);
          },
        },
        {
          title: this.$t('home.applies'), // 涨跌幅
          dataIndex: 'roses',
          key: 'roses',
          scopedSlots: { customRender: 'roses' },
          sorter: (a, b) => {
            if (a.contractType === 'E') {
              return parseFloat(a.rose) - parseFloat(b.rose);
            }
            return parseFloat(a.roses) - parseFloat(b.roses);
          },
        },
        {
          title: this.$t('home.chart'), // 行情图
          dataIndex: 'chart',
          key: 'rose',
          hidden: !this.fromHome,
          width: 160,
          scopedSlots: { customRender: 'chart' },
        },
        {
          title: this.$t('home.height'), // 最高价
          dataIndex: 'high',
          key: 'high',
          hidden: this.fromHome,
          sorter: (a, b) => a.high - b.high,
        },
        {
          title: this.$t('home.low'), // 最低价
          dataIndex: 'low',
          key: 'low',
          hidden: this.fromHome,
          sorter: (a, b) => a.low - b.low,
        },
        {
          title: this.$t('home.H_volume'),
          dataIndex: 'vol',
          key: 'vol',
          scopedSlots: { customRender: 'vol' },
          hidden: this.fromHome,
          sorter: (a, b) => a.vol - b.vol,
        },
        {
          title: this.$t('home.H_turnover'),
          dataIndex: 'amount',
          key: 'amount',
          scopedSlots: { customRender: 'amount' },
          hidden: this.fromHome,
          width: 170,
          sorter: (a, b) => a.amount - b.amount,
        },
        {
          title: this.$t('order.exchangeOrder.hisOrderOptions'),
          align: 'right',
          width: this.actionWidth,
          scopedSlots: { customRender: 'action' },
        },
      ].filter(item => !item.hidden);
    },
    actionWidth() {
      if (this.fromHome) {
        return 260;
      }
      if (this.marketCurrent === 'futures') {
        return 140;
      }
      return 240;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * 判断是否收藏
     */
    isCollected(symbol) {
      const mySymbolList = myStorage.get('mySymbol') || [];
      return mySymbolList.includes(symbol);
    },
    init() {
      this.$bus.$on('EXCHANGE_MARKET_KLINE_DATA', (data) => {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          this.$set(this.klineDataList, item, data[item]);
        });
      });
      this.$bus.$on('FUTURE_MARKET_KLINE_DATA', (data) => {
        const keys = Object.keys(data);
        keys.forEach((item) => {
          this.$set(this.futureKlineDataList, item, data[item]);
        });
      });
    },
    multiple(data) {
      const contractInfo = this.contractList.filter(item => item.wsDatakey === data.wsDatakey);
      if (contractInfo && contractInfo.length) {
        // eslint-disable-next-line no-return-assign
        return contractInfo[0].multiplier;
      }
      return 1;
    },
    formatNumber(num) {
      // 只保留两位小数
      // if (isNaN(num)) return num;
      let newNum = parseFloat(num).toFixed(2);

      // 如果小数点后是两个0，就去掉
      if (newNum.slice(-1) === '0' && newNum.slice(-2, -1) === '0') {
        newNum = newNum.slice(0, -3);
      }

      // 如果整数位超过9位，就用B表示
      if (num > 1000000000) {
        return newNum = (num / 1000000000).toFixed(2) + 'B';
      }

      // 如果整数位超过7位，就用M表示
      if (num > 1000000) {
        return newNum = (num / 1000000).toFixed(2) + 'M';
      }

      return newNum;
    },
    bandLink(data, symbol) {
      if (symbol && symbol.contractType === 'E') {
        this.$router.push(`/futures/${symbol.contractName}`);
      } else if (data) {
        myStorage.set('sSymbolName', data);
        myStorage.set('markTitle', data.split('/')[1]);
        this.$router.push(`/trade/${data.replace('/', '_')}`);
      }
    },
    getChardDataList(record) {
      if (record.contractType === 'E') {
        return this.futureKlineDataList[record.name] || [];
      }
      return this.klineDataList[record.name] || [];
    },

    /**
     * K线颜色
     * @param {*} rose
     */
    getKeyLineClass(record) {
      const rose = record.contractType === 'E' ? record.rose : record.roses;
      const numRose = `${rose}`.replace('%', '');

      return Number(numRose) > 0 ? fixUpDownColor('u-1-cl') : fixUpDownColor('u-4-cl');
    },

    getFutureRoseClass(rose) {
      return rose > 0 ? 'color-up' : 'color-down';
    },

    // 24小时行情 涨跌幅 的背景、样色的class
    itemRoseClass(rose) {
      let bgClass = null;
      if (rose.class === 'u-1-cl') {
        bgClass = 'color-up';
      } else if (rose.class === 'u-4-cl') {
        bgClass = 'color-down';
      }
      return [rose.class, bgClass];
    },

    marketClick(symbol) {
      this.$bus.$emit('SWITCH-STORE', symbol);
    },

    openModal(coinName) {
      if (!coinName || coinName.indexOf('/') === '-1') {
        return;
      }
      this.$refs.marketModal.show(coinName);
    },

    addOptional() {
      this.$emit('update:marketCurrent', 'USDT');
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/global.scss";
.market-table {
  // min-height: 548px;
  ::v-deep .ant-table {
    .ant-table-thead > tr > th {
      background-color: $white;
      padding: 11px 0 11px 24px;
      color: $gray;
      font-size: 12px;
      line-height: 14px;
      border: none;
      font-family: "Regular";
      // font-family: 'Regular';
      .ant-table-column-sorters:hover::before {
        background-color: $white;
      }
      &:last-child {
        padding-right: 24px;
      }
      .off {
        color: $gray;
      }
      .on {
        color: $blue;
      }
      .ant-table-column-title {
        font-weight: 400;
      }
      .ant-table-column-sorter-inner-full {
        margin-top: -0.55em;
      }
      .anticon {
        height: 0.4em;
        line-height: 0.4em;
      }
    }
    .ant-table-tbody > tr > td {
      border: none;
      padding: 14px 0 14px 24px;
      height: 36px;
      color: $light-ft;
      line-height: 20px;
      font-family: "Regular";
      vertical-align: middle;
      &:last-child {
        padding-right: 24px;
      }
    }
    .ant-table-placeholder {
      border: none;
    }
    .ant-table-row {
      background-color: $white;
    }
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background-color: $light-bg;
    }
  }
  .market-table-name {
    padding-left: 26px;
    position: relative;
  }

  .market-table-name-noCollect {
    padding-left: 0;
  }
}

.flex-box-column {
  // height: 100%;
  display: flex;
  flex-direction: column;
}

.icon-start {
  width: 18px;
  height: 18px;
  background: url("../../../assets/svg/star-default.svg") no-repeat;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background-position: 1.5px;
  cursor: pointer;
}

.tableWithKLine {
  ::v-deep .ant-table {
    .ant-table-tbody > tr > td {
      height: 68px !important;
      padding: 9px 0 10px 24px;
      box-sizing: border-box;
    }
  }
}

.market-empty {
  ::v-deep .ant-empty {
    margin-top: 57px;
    .ant-empty-image {
      margin-bottom: 0;
    }
    .ant-empty-description {
      color: $light-ft;
    }
    .ant-empty-footer {
      margin-top: 24px;
      .ant-btn {
        background-color: $blue;
        color: $white;
        height: 40px;
        padding: 0 16px;
        border: none;
        font-weight: 500;
        &:hover {
          background-color: $blue;
          color: $white;
        }
      }
    }
  }
}
.market-pagination {
  margin-top: 16px;
  margin-bottom: 30px;
  ::v-deep.ant-pagination {
    .ant-pagination-item {
      margin-right: 4px;
      border: none;
      font-size: 14px;
      width: 28px;
      height: 28px;
      font-family: "Regular";
      font-weight: 500;
      a {
        color: $light-ft;
        line-height: 28px;
        &:hover {
          background-color: $light-bg;
          border-radius: 4px;
        }
      }
    }
    .ant-pagination-item-active {
      background-color: $blue;
      border: none;
      a {
        color: $white;
        &:hover {
          background-color: $blue;
        }
      }
    }
    .ant-pagination-prev {
      margin-right: 8px;
    }
    .ant-pagination-next {
      margin-left: 4px;
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      .anticon {
        color: $light-ft;
      }
    }
    .ant-pagination-disabled {
      .anticon {
        color: $gray;
      }
    }
  }
}
.ml-4 {
  margin-left: 4px;
}
.mr-20 {
  margin-right: 20px;
}
.f-gray {
  color: $gray;
}
.f-light {
  color: $blue;
}
.f-12 {
  font-size: 12px;
  line-height: 14px;
}
.star-light {
  width: 18px;
  height: 18px;
  background: url("../../../assets/svg/star-active.svg") no-repeat;
  background-position: 1.5px;
}

.f-not-weight {
  font-weight: normal;
  font-family: "Regular";
}
.cursor-p {
  cursor: pointer;
}

.dark {
  .market-pagination {
    ::v-deep.ant-pagination {
      .ant-pagination-item {
        a {
          color: $gray;
          &:hover {
            color: $white;
            background-color: $dark-bg-second;
          }
        }
      }
      .ant-pagination-item-active {
        background-color: $blue;
        a {
          color: $white;
          &:hover {
            background-color: $blue;
          }
        }
      }
      .ant-pagination-prev,
      .ant-pagination-next {
        .anticon {
          color: $white;
        }
      }
      .ant-pagination-disabled {
        .anticon {
          color: $gray;
        }
      }
    }
  }
  .market-table {
    ::v-deep .ant-table {
      .ant-table-thead > tr > th {
        background-color: $dark-bg;
        color: $gray;
        .ant-table-column-sorters:hover::before {
          background-color: $dark-bg;
        }
      }
      .ant-table-placeholder {
        border: none;
        background-color: $dark-bg;
      }
      .ant-table-tbody > tr > td {
        color: $white;
        background-color: $dark-bg;
      }
      .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
        background-color: $dark-bg-second;
      }
    }
  }
  .market-empty {
    .empty-text {
      color: $white;
    }
  }
}
.view-more {
  margin: 12px auto;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  width: 200px;
}
</style>
